if (!customElements.get('lb-retailer-strip')) {
  customElements.define('lb-retailer-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-ready')) return;
      const button = this.querySelector('.lb-retailers__pause');
      if (!button) return;
      this.classList.add('is-ready');
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-pause-label]').textContent = paused ? 'Resume logos' : 'Pause logos';
        button.querySelector('.lb-retailers__pause-icon').textContent = paused ? '\u25b7' : '\u2161';
      });
    }
  });
}
